import ModalError from "../Components/ModalError/ModalError";
import errorImageScoreRecaptcha from "../assets/Images/errorImageScoreRecaptcha.svg";
import iconHand from "../assets/Images/IconHand.svg";
import iconSuccess from "../assets/Images/IconSuccess.svg";

function ErrorDataModal({ redirectionHome }) {
    return (
        <ModalError
            isShowing={true}
            buttonClose={false}
            redirectFunction1={redirectionHome}
            title="El sistema no se encuentra disponible"
            message="Inténtalo nuevamente más tarde. Nuestro equipo está trabajando para brindarte una pronta solución."
            buttonText="Entendido"
            image={errorImageScoreRecaptcha}
            buttonBack={false}
        />
    );
}

function ErrorUnauthorizedModal({ redirectionHome, timeOutRedirect }) {
    if(timeOutRedirect){
        setTimeout(() => {
            redirectionHome();
        }, timeOutRedirect);
    }
    return (
        <ModalError
            isShowing={true}
            buttonClose={false}
            redirectFunction1={redirectionHome}
            title="Validación fallida"
            message="Vuelve a ingresar e inténtalo nuevamente"
            image={errorImageScoreRecaptcha}
            buttonBack={false}
        />
    );
}

function AlertCancelModal({ continueFlow, redirectCancelOperation }) {
    return (
        <ModalError
            isShowing={true}
            buttonClose={false}
            redirectFunction1={continueFlow}
            redirectFunction2={redirectCancelOperation}
            title="¿Qué deseas hacer?"
            message=""
            buttonText="Volver a biometría"
            buttonTextBack="Salir de biometría"
            image={iconHand}
            widthButton="300px"
            buttonBack={true}
        />
    );
}

function AlertRenewModal({ continueFlow, renewFunction }) {
    return (
        <ModalError
            isShowing={true}
            buttonClose={false}
            redirectFunction1={renewFunction}
            redirectFunction2={continueFlow}
            title="¿Deseas generar un nuevo código QR?"
            message="Si generas un nuevo código, la autenticación actual se cancelará y deberás iniciar el proceso nuevamente."
            buttonText="Confirmar"
            buttonTextBack="Cancelar"
            image={iconHand}
            widthButton="300px"
            buttonBack={true}
        />
    );
}

function CameraErrorModal({ restartFlow, redirectCancelOperation, titleError, messageError, iconType, buttonBack, secondaryMessage }) {
    const errorIcon = iconType === 'error' ? errorImageScoreRecaptcha : iconHand;
    const buttonText = buttonBack ? 'Volver al inicio' : 'Entendido';
    const buttonFunction = buttonBack ? restartFlow : redirectCancelOperation;
    return (
        <ModalError
            isShowing={true}
            buttonClose={false}
            redirectFunction1={buttonFunction}
            redirectFunction2={redirectCancelOperation}
            title={titleError}
            message={messageError}
            buttonText={buttonText}
            buttonTextBack="Salir de biometría"
            image={errorIcon}
            widthButton="300px"
            buttonBack={buttonBack}
            secondaryMessage={secondaryMessage}
        />
    );
}

function RetryModal({ restartFlow, redirectCancelOperation, titleTries, messageTries }) {
    const errorTitleTries = `${titleTries} de nuevo`;
    const errorMessageTries = `Tuvimos problemas con tu ${messageTries}.`;
    return (
        <ModalError
            isShowing={true}
            buttonClose={false}
            redirectFunction1={restartFlow}
            redirectFunction2={redirectCancelOperation}
            title={errorTitleTries}
            message={errorMessageTries}
            buttonText="Intentar nuevamente"
            buttonTextBack="Salir"
            image={iconHand}
            widthButton="300px"
            buttonBack={true}
        />
    );
}

function FailedModal({ restartFlow }) {
    return (
        <ModalError
            isShowing={true}
            buttonClose={false}
            redirectFunction1={restartFlow}
            title="No logramos verificar tu identidad"
            message="Si quieres intentarlo de nuevo, regresa a tu computadora y genera un nuevo código QR."
            buttonText="Salir"
            image={errorImageScoreRecaptcha}
            widthButton="300px"
            buttonBack={false}
        />
    );
}

function SuccessModal({ restartFlow }) {
    const title = "Tu identidad se verificó";
    const message = "Ahora puedes continuar en tu computador.";
    const secondaryMessage = <strong>Ya puedes cerrar esta ventana.</strong>;
    return (
        <ModalError
            isShowing
            buttonClose={false}
            redirectFunction1={restartFlow}
            title={title}
            message={message}
            buttonText="Salir"
            image={iconSuccess}
            widthButton="140px"
            buttonBack={false}
            secondaryMessage={secondaryMessage}
        />
    );
}
export function HandlerError({ machine, showAlertCancel, showAlertRenew, continueFlow, redirectCancelOperation, restartFlow, redirectionHome, titleError, messageError, iconType, buttonBack, secondaryMessage, timeOutRedirect, renewFunction}) {
    const messages = getmessages(machine.context.enrollment)
    const titleTries  = messages.titleTries;
    const messageTries = messages.messageTries;
    return ( 
        <>
            {machine.matches("errorData") && (
                <ErrorDataModal redirectionHome={redirectionHome} />
            )}
            {machine.matches("unauthorized") && (
                <ErrorUnauthorizedModal redirectionHome={redirectionHome} timeOutRedirect={timeOutRedirect}/>
            )}
            {showAlertCancel && (
                <AlertCancelModal continueFlow={continueFlow} redirectCancelOperation={redirectCancelOperation} />
            )}
            {machine.matches("cameraError") && (
                <CameraErrorModal restartFlow={restartFlow} redirectCancelOperation={redirectCancelOperation} titleError={titleError} messageError={messageError} iconType={iconType} buttonBack={buttonBack} secondaryMessage={secondaryMessage}/>
            )}
            {machine.matches("retry") && (
                <RetryModal restartFlow={restartFlow} redirectCancelOperation={redirectCancelOperation} titleTries={titleTries} messageTries={messageTries} />
            )}
            {showAlertRenew && (
                <AlertRenewModal continueFlow={continueFlow} renewFunction={renewFunction} />
            )}
            {machine.matches("failed") && (
                <FailedModal restartFlow={redirectionHome} />
            )}
            {machine.matches("successProcess") && (
                <SuccessModal restartFlow={redirectionHome} />
            )}
        </>
    )
};

function getmessages(isEnrollment){
    const titleTries = isEnrollment? "Regístrate" : "Autentícate";
    const messageTries = isEnrollment? "registro" : "autenticación";
    return {titleTries, messageTries}
}